<div class="row mx-0">
  <div class="col-12 col-lg-6 bg-white login-content-left d-flex justify-content-center align-items-center"
       style="min-height: 100vh; padding-bottom: 75px;">

    <div class="content-login">
      <!-- <img src="{% static 'img/eficacia-brand.png' %}" alt="eficacia" class="ig-fluid mb-5"> -->
      <h1 class="font-size-20 font-solomon">{{ 'Nueva contraseña' | translate }}</h1>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <app-alert></app-alert>
        <div class="form-group">
          <label for="password">{{ 'Contraseña' | translate }}</label>
          <input type="password" id="password" class="form-control"  formControlName="password" placeholder="{{ 'Contraseña' | translate }}">
        </div>
        <div class="form-group">
          <label for="password_confirm">{{ 'Confirmar Contraseña' | translate }} *</label>
          <input type="password" id="password_confirm" class="form-control" formControlName="confirmPassword" placeholder="{{ 'confirmar Contraseña' | translate }}">
          <div *ngIf="f.confirmPassword.invalid" >
            <div *ngIf="f.confirmPassword.errors?.mustMatch">
              {{ 'La contraseña no coincide con la anterior' | translate }}
            </div>
          </div>
        </div>

        <button type="submit" class="btn btn-primary btn-blue-dark-rounded mb-3" [disabled]="loading || form.invalid" > <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span> {{ 'Restablecer contraseña' | translate }}</button>

      </form>

    </div>

  </div>
  <div class="col-12 col-lg-6 d-flex justify-content-start align-items-end p-3 p-lg-5"
       style="background: url('assets/img/bg-login.png'); background-size: cover; padding-bottom: 75px!important;">
    <h2 class="font-size-50 font-solomon text-white m-0 m-lg-5" style="max-width: 530px;">{{ 'Un ecosistema para la transformación digital de las clientes del futuro, hoy.' | translate }}</h2>
  </div>
  <app-footer></app-footer>
</div>
